import React from 'react';
import { Switch, Route, useLocation } from 'react-router-dom';
import { Formik, Form } from 'formik';
import Button from 'components/button';
import AccountType from 'forms/account-type';
import EcpStatus from 'forms/ecp-status';
import ContactInfo from 'forms/contact-info';
import BusinessInfo from 'forms/business-info';
import BackgroundInfo from 'forms/background-info';
import Finish from 'forms/finish';
import { pathnames } from 'lib/routes';
import validation from 'lib/validation';
import { useApplication } from 'lib/application-provider';
import { useRoute } from 'lib/route-provider';
import analytics from 'lib/analytics';

const MultiForm = () => {
  const location = useLocation();
  const { goToNextStep, getCurrentStep } = useRoute();
  const application = useApplication();
  const schema = validation[location.pathname];

  const submitApplication = async () => {
    const response = await application.submit();
    if (response && !response.validation_errors) {
      goToNextStep({});
    }
  };

  const handleSubmit = async (values, actions) => {
    // remove keys not specified in the current page schema
    const stripped_values = await schema.validate(values, {
      stripUnknown: true,
    });
    const response = await application.update(stripped_values);

    if (response && !response.error) {
      if (location.pathname === pathnames.complete_application) {
        await submitApplication();
      } else {
        const completedStep = getCurrentStep();
        goToNextStep(response);

        analytics.track('Application Step Completed', {
          step_name: completedStep.name,
        });

        // not pretty, but this ensures the submit button stays disabled during
        // the transition to the next screen
        await new Promise((resolve) => setTimeout(resolve, 200));
      }
    }

    if (response && response.error) {
      actions.setErrors(response.error.message); // may be overriding frontend validation errors from displaying
    }
  };

  return (
    <>
      {application.values ? (
        <Formik
          initialValues={application.values}
          enableReinitialize
          onSubmit={handleSubmit}
          validationSchema={schema}
        >
          {({ isSubmitting }) => (
            <Form>
              <Switch location={location}>
                <Route path={pathnames.account_type}>
                  <AccountType />
                </Route>
                <Route path={pathnames.contact_info}>
                  <ContactInfo />
                </Route>
                <Route path={pathnames.business_info}>
                  <BusinessInfo />
                </Route>
                <Route path={pathnames.ecp_status}>
                  <EcpStatus />
                </Route>
                <Route path={pathnames.background_info}>
                  <BackgroundInfo />
                </Route>
                <Route path={pathnames.complete_application}>
                  <Finish />
                </Route>
              </Switch>

              {/* Hide the submit button on the Persona verification screen.
            Completing an Inquiry acts as "submit" */}
              {location.pathname === pathnames.contact_info ? null : (
                <Button primary type="submit" disabled={isSubmitting}>
                  {location.pathname === pathnames.complete_application
                    ? 'Finish'
                    : 'Continue'}
                </Button>
              )}
            </Form>
          )}
        </Formik>
      ) : // TODO: proper loading or error component
      null}
    </>
  );
};

export default MultiForm;
